import React from "react";

const RazorIcon = ({ title, ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 1186 406.9"
    style={{ enableBackground: "new 0 0 1186 406.9" }}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <g>
      <path
        d="M476.4,292.1l-1.3-105.8c0-50.5-51.8-58.5-124.8-58.5c-25.9,0-31.2,9.8-31.2,16.9c0,19,20.4,16.9,40.2,16.9
  		c17.7,0,34.9,0.5,34.9,13.8c0,13.5-5.6,17.2-37,17.2c-75.4,0-106.3,36.5-102.1,68.2c4,30.9,35.4,49.7,87.8,49.7h108.7
  		C467.7,310.9,478.2,306.1,476.4,292.1 M382.5,276.8c-24.6,11.6-50.3,8.7-57.4-6.1c-6.9-14.8,7.4-36.2,32.3-47.6
  		c24.6-11.6,50.3-8.7,57.4,6.1C421.6,244,407.4,265.4,382.5,276.8"
      />
      <path
        d="M202.9,235.8c-2.6-3.4-3.4-7.7-3.4-12.7c0-5.6,4.5-11.9,14-19.8c7.1-4.5,12.2-7.9,15.9-10.6
  		c4.5-3.4,7.1-5.6,13.2-13.5c7.1-10.6,10.6-21.2,10.6-33.1c0-46.6-37.8-72.7-102.9-72.7H76.5c-32.8,0-74.6,6.6-74.6,71.9v137.5
  		c0,26.4,14,27.2,37,27.2c20.1,0,41.3-3.4,41.3-21.7v-41.3c0-10.1,7.9-17.2,18.2-17.2c15.6,0,16.9,3.4,39.4,30.4l31.7,36
  		c7.1,6.9,17.5,14,32.5,14h31.7c15.9,0,25.7-4.2,23.8-11.4C252.9,285.2,202.9,235.8,202.9,235.8 M134.7,184.7
  		c-29.1,13.5-59.2,10.3-67.4-7.1s8.7-42.6,37.8-56.1s59.2-10.3,67.4,7.1C180.7,146.1,163.8,171,134.7,184.7"
      />
      <path
        d="M664.4,277h-32.8c-16.4,0-43.1-0.5-22.2-21.2c3.7-3.7,68.5-74.1,68.5-74.1c12.4-12.4,23.5-20.6,29.6-36.8
  		c4-10.8-4.8-17.2-19.8-17.2H552c-15.9,0-25.9,6.3-25.9,16.4c0,11.9,10.3,17.2,22.5,17.2h14.5c15.3,0,45.8-1.3,32.3,12.2
  		c-7.7,7.4-81.5,82.8-81.5,82.8c-12.7,11.6-24.1,27-24.1,37.3c0,14.3,6.6,17.5,22,17.5h141.8c21.4,0,41.5-5.8,43.1-16.7
  		C698,285.5,682.4,277,664.4,277"
      />
      <path
        d="M1106.1,128.4c-17.2,0-37.6-1.9-78.8,5.8c-41,7.7-52.9,15.3-52.9,32.3v116.9c0,17.7,4.8,27.2,40.7,27.2
  		c37.6,0,42.8-8.7,42.8-25.9l-0.3-20.4c0-71.9-7.4-95.7,40.7-102.6c38.4-5.3,85.4,20.4,85.4-11.4
  		C1183.9,137.7,1152.4,128.4,1106.1,128.4"
      />
      <path
        d="M953,190l-0.3-1.1l-0.3-1.3c-12.7-40.7-73.3-62.2-118.8-62.2H825c-45.2,0-105.8,21.4-118.5,62.2L706,189
  		l-0.3,1.1c-2.6,9.5-4.2,19.6-4.2,29.9c0,10.6,1.3,20.4,4,30.2l0.5,1.6c11.6,41.3,72.7,61.9,118.5,61.9h9
  		c46.8,0,110.3-21.7,119.8-64.8c2.4-9.3,3.7-19,3.7-28.8C957,209.6,955.6,199.5,953,190 M849.8,262.2c-38.6,18-79.1,13.8-89.9-9.3
  		c-10.8-23.3,11.9-56.9,50.5-74.9c38.9-18,79.1-13.8,89.9,9.5C911.2,210.7,888.7,244.2,849.8,262.2"
      />
    </g>
  </svg>
);

export default RazorIcon;
